import { generateDensitySrcSet } from '@core/Components/HeycarImage/GenerateDensitySrcSet';
import { Typography } from '@gds/Typography/Typography';
import { umbracoImageLoaderByHeight } from '@umbraco/Utils/UmbracoImageLoader';

import { TrackedLink } from '../../TrackedLink/TrackedLink';

import styles from './StandardSubNavItem.module.css';

interface StandardSubNavItemProps {
  label: string;
  href?: string;
  desc?: string;
  logo?: string[];
  imageAltTexts?: string[];
  isNavMenuList?: boolean;
  origin?: 'header' | 'footer';
  navItemId?: string;
}

export const StandardSubNavItem: React.FC<StandardSubNavItemProps> = ({
  label,
  href,
  desc,
  logo,
  imageAltTexts,
  isNavMenuList = false,
  origin,
  navItemId,
}) => (
  <TrackedLink
    className={styles.subNavItemWrapper}
    href={href}
    trackingObj={{ label: label, href: href }}
    origin={origin}
    isNavMenuList={isNavMenuList}
    navItemId={navItemId}
  >
    {logo && logo?.length > 0 && (
      <div className={styles.logoImgWrapper}>
        <img
          src={logo[0]}
          srcSet={generateDensitySrcSet(logo[0], umbracoImageLoaderByHeight, 24)}
          alt={imageAltTexts?.[0] || label}
        />
      </div>
    )}
    <span>{label}</span>
    {desc && isNavMenuList && (
      <Typography variant="body4" className={styles.subNavDesc}>
        {desc}
      </Typography>
    )}
  </TrackedLink>
);
